import { Group, Rect, Text } from 'react-konva';

import Konva from 'konva';

interface RackRectProps extends Konva.RectConfig {
  rectAttrs?: Konva.RectConfig;
  textAttrs?: Konva.TextConfig;
  onClick?: any;
  onDragMove?: (e: Konva.KonvaEventObject<MouseEvent>) => void;
  onDragEnd?: (e: Konva.KonvaEventObject<MouseEvent>) => void;
}

export const RackRect: React.FC<RackRectProps> = ({
  rectAttrs,
  textAttrs,
  onClick,
  onDragMove,
  onDragEnd,
  ...props
}) => {
  return (
    <Group draggable {...props} onClick={onClick} onDragMove={onDragMove} onDragEnd={onDragEnd}>
      <Rect {...rectAttrs} strokeScaleEnabled={false} />

      <Text {...textAttrs} fill={'#FFFFFF'} fontStyle="bold" />
    </Group>
  );
};
